<template>
  <!-- Active prompt: the web client has no service worker, so we detect a new release by
       comparing the running build (__APP_VERSION__) against the published VersionNr and
       nudge the user to refresh. The cache-control headers mean a refresh actually loads
       the new bundle. -->
  <v-snackbar
    v-model="show"
    location="top"
    color="warning"
    :timeout="-1"
    multi-line
  >
    <v-icon class="me-2">mdi-update</v-icon>
    A new version of WayWyser{{ publishedVersion ? ` (${publishedVersion})` : "" }} is available.
    <template #actions>
      <v-btn variant="text" @click="refresh">Refresh</v-btn>
      <v-btn icon="mdi-close" variant="text" @click="show = false" />
    </template>
  </v-snackbar>
</template>

<script setup>
/* global __APP_VERSION__ */
import { ref, onMounted } from "vue";
import { getLatestVersion } from "@/api/softwareVersion";

const runningBuild = typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "";
const show = ref(false);
const publishedVersion = ref("");

// Numeric-dotted compare: -1/0/1, or null if not comparable.
function compareVersions(a, b) {
  if (!a || !b) return null;
  const pa = String(a).split(".").map((n) => parseInt(n, 10));
  const pb = String(b).split(".").map((n) => parseInt(n, 10));
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const x = pa[i] || 0;
    const y = pb[i] || 0;
    if (x !== y) return x < y ? -1 : 1;
  }
  return 0;
}

function refresh() {
  window.location.reload();
}

onMounted(async () => {
  try {
    const v = await getLatestVersion();
    publishedVersion.value = v?.versionNr || "";
    const cmp = compareVersions(runningBuild, publishedVersion.value);
    show.value = cmp != null && cmp < 0; // only when the build is behind
  } catch {
    // Can't determine (e.g. not authenticated) — show nothing.
  }
});
</script>
